import { createContext, useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { io } from 'socket.io-client';
import { checkAuth } from '../../utils/authCheck';
import { OnlineProvider } from './OnlineProvider';

const SocketContext = createContext(null);

export function SocketProvider() {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const newSocket = io(process.env.REACT_APP_API_URL, {
            withCredentials: true,
            transports: ['polling', 'websocket'],
            autoConnect: false,
            // Функция, а не объект: токен перечитывается из localStorage
            // на каждом (пере)подключении, поэтому после refresh берётся свежий.
            auth: (cb) => cb({ token: localStorage.getItem('accessToken') }),
        });

        // Гость без токена не подключается — комнату определяет сервер по JWT.
        if (localStorage.getItem('accessToken')) {
            newSocket.connect();
        }

        let refreshing = false;
        newSocket.on('connect_error', async (err) => {
            if (err?.message !== 'unauthorized' || refreshing) return;
            refreshing = true;
            try {
                // checkAuth обновит accessToken в localStorage, если он протух.
                await checkAuth();
                if (localStorage.getItem('accessToken')) {
                    newSocket.connect();
                }
            } catch {
                // нет валидной сессии — остаёмся без сокета
            } finally {
                refreshing = false;
            }
        });

        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            <OnlineProvider>
                <Outlet />
            </OnlineProvider>
        </SocketContext.Provider>
    );
}

export const useSocket = () => useContext(SocketContext);
